











































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import FormPage from "./FormPage/index.vue";
import ChartPage from "../../../components/ChartPage/index.vue";
import LogTable from "../../../components/LogTable/index.vue";
import { dateFormat } from "../../../util";
import FileList from "../../../components/FileList/index.vue";
import UploadFile from "../../../components/UploadFile/index.vue";

@Component({
  name: "WbenReadProcess",
  components: {
    UploadFile,
    FormPage,
    ChartPage,
    LogTable,
    FileList
  }
})
export default class WbenReadProcess extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessId: any = null;
  private processData: any = null;
  private flowData: any = null;
  private title: any = "";
  private userName: any = "";
  private timeText: any = "";
  private prefix: string = "";
  private fileData: any = [];

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      this.businessId = this.processData.businessId;
      this.getFlowData();
    }
  }

  /*流程事项数据查询*/
  async getFlowData() {
    const params = {
      businessId: this.processData.businessId,
      clientType: "web"
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getFinishDetail(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取流程事项数据失败:" + message);
        return false;
      }
      this.title = data.businessName;
      this.userName = data.run.createUserName;
      this.timeText = data.run.createTime ? dateFormat(data.run.createTime) : "--";
      this.flowData = data;
      this.fileData = data.atts;
    } catch (error: any) {
      this.$message.error("获取流程事项数据失败:" + error);
    }
  }

  /*返回表单数据*/
  async getBack() {
    return (await (this.$refs.webReadProcess as any).getBack()) as any;
  }
}
